import styled from "styled-components";
import type { TimeSeriesLineStyle } from "./seriesTypes";

/**
 * The line mark a legend chip or a values row uses to point at a series: the same stroke weight
 * as the canvas line, in `currentColor`, repeating the series' dash so the style reads off the
 * chip. 13px fits three 3px dashes with 2px gaps. Public so a consumer's own source or channel
 * mark is this mark rather than a copy of its measurements; set the colour on the element or
 * an ancestor and pass the series' `lineStyle` as `$lineStyle`.
 */
export const SeriesSwatch = styled.span<{ $lineStyle?: TimeSeriesLineStyle }>`
  display: inline-block;
  flex-shrink: 0;
  width: 13px;
  height: 2px;
  border-radius: 1px;
  vertical-align: middle;
  background: ${({ $lineStyle }) =>
    $lineStyle === "dashed"
      ? "repeating-linear-gradient(90deg, currentColor 0 3px, transparent 3px 5px)"
      : "currentColor"};
`;
